import { useState } from "react";
import { useHistory } from "react-router-dom";
import { usePunditUserContext } from "@/react/contexts";
import {
  chatRoomPath,
  getRouteWithPrevLocation,
} from "@/react/helpers/urlHelpers";
import { useChatUIStore } from "@/react/hooks/chatsV2/store";
import { useChatRoom } from "@/react/hooks/chatsV2/useChatRoom";
import { DIRECT_CHAT_ROOM } from "@circle-react/components/constants";

export const useSendMessageToUser = () => {
  const { findOrCreateChatRoom } = useChatRoom();
  const { isViewOnlyMasquerading } = usePunditUserContext();

  const history = useHistory();
  const { setLiveChatRoomUuid } = useChatUIStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleMessageMember = async (memberId: string) => {
    if (isViewOnlyMasquerading) {
      return;
    }
    setIsLoading(true);
    const chatRoomUuid = (await findOrCreateChatRoom({
      kind: DIRECT_CHAT_ROOM,
      community_member_ids: [memberId],
    })) as string | null;

    if (!chatRoomUuid) {
      return;
    }
    const isLiveStream = history.location.pathname.includes("/live");
    if (isLiveStream) {
      setLiveChatRoomUuid(chatRoomUuid);
      return;
    }
    setIsLoading(false);
    history.push(
      getRouteWithPrevLocation({ url: chatRoomPath({ uuid: chatRoomUuid }) }),
    );
  };

  return {
    handleMessageMember,
    isLoading,
  };
};
